import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminModeContext = createContext({ adminMode: false, setAdminMode: () => {} });

export function AdminModeProvider({ children }) {
  const [adminMode, setAdminMode] = useState(false);

  useEffect(() => {
    const persisted = localStorage.getItem('adminModeEnabled');
    if (persisted != null) {
      setAdminMode(persisted === 'true');
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('adminModeEnabled', String(adminMode));
  }, [adminMode]);

  return (
    <AdminModeContext.Provider value={{ adminMode, setAdminMode }}>
      {children}
    </AdminModeContext.Provider>
  );
}

export function useAdminMode() {
  return useContext(AdminModeContext);
}



